import { useState, useEffect } from "react"
import * as React from "react"
import { Grid, Typography, Button, TextField } from "@mui/material"
import { useApp } from "../../AppProvider"
import { useNavigate } from "react-router"
import { makeStyles } from "@mui/styles"
import { useForm } from "react-hook-form"
import logoStock from "./../../assets/spinmovilFullLogo.svg"
import { recoverPassword } from "./services/api"
import { email_regex } from "../../helpers/regular_expressions"
import fondoLogin from "./../../assets/fondoLogin.png"
import PrimaryButton from "../../components/PrimaryButton"

const useStyles = makeStyles(() => ({
  recoverRoot: {
    height: "100vh",
    backgroundColor: "#FFFFFF",
    fontFamily: "Ubuntu, sans-serif",
  },
  loginIcon: {
    width: "40vw !important",
    margin: "0px !important",
  },

  baseFrame: {
    height: "auto",
    width: "36.5%",
    ["@media (max-width: 1300px)"]: {
      width: "30%",
    },
    ["@media (max-width: 1200px)"]: {
      width: "25%",
    },
  },
  formInput: {
    "& .MuiInputBase-root": {
      height: "53px !important",
    },
    "& .MuiInputLabel-root": {
      color: "#000000 ",
      fontFamily: "Ubuntu",
      fontSize: "15px !Important",
    },
    "& .Mui-focused": {
      color: "#000000 !important",
    },
    "& .Mui-error": {
      color: "#d32f2f !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: "8px",
        borderColor: "#4E5589",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4E5589",
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
  },
  phoneImage: {
    position: "absolute",
    height: "80%",
    marginRight: "8%",
  },
  titleText: {
    color: "#F5F5F5",
    margin: 0,
    fontWeight: "400",
    fontFamily: "Ubuntu, sans-serif",
    fontSize: "35px",
    "& b": {
      color: "#1BC3DD",
      fontWeight: "700",
    },
    "& strong": {
      color: "#F5F5F5",
      margin: 0,
      fontWeight: "700",
      fontFamily: "Ubuntu, sans-serif",
      fontSize: "35px",
    },
    ["@media (max-width: 1370px)"]: {
      fontSize: 30,
    },
  },
  titleImage: {
    width: "35vw",
    position: "absolute",
    bottom: "10vh",
    right: "45.9%",
  },
  PasswordIcon: {
    objectFit: "cover",
    width: "100%",
    height: "100%",
    background: "rgba(6 153 226)",
  },
  esmsLogo: {
    width: "320px",
    marginBottom: "56px !important",
    ["@media (max-width: 1300px)"]: {
      width: "15vw",
    },
  },
  acceptButton: {
    borderColor: "#4E5589 !important",
    textTransform: "none !important",
    borderWidth: "2px !important",
    borderRadius: "8px !important",
    color: "#4E5589 !important",
    height: "53px !important",
    "&:hover": {
      /* background: " linear-gradient( #008C0D 33.74%, #00BF19 96.06%);", */
      background: "#4E5589 !important",
      boxShadow:
        "0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1) !important",
      color: "white !important",
    },
  },
  blueButton: {
    background: "#4E5589 !important",
    borderColor: "#4E5589 !important",
    textTransform: "none !important",
    borderWidth: "2px !important",
    borderRadius: "8px !important",
    color: "white !important",
    height: "53px !important",
  },
  formFrame: {
    borderRadius: "8px",
    backgroundColor: "#F7F7F7",
    height: "747px",
    width: "528.56px",
    display: "flex",
    padding: "154px 0px 0px 0px",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "center",
    ["@media (max-height: 1000px)"]: {
      height: "calc(95vh - 154px)",
    },
    ["@media (min-height: 1001px)"]: {
      height: "747px",
    },
  },
}))

const RecoverPassword = () => {
  const navigate = useNavigate()
  const classes = useStyles()
  const { showNotification, currentUser, clearCurrentUser } = useApp()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const { email: emailError } = errors
  const [recoverSuccess, setRecoverSuccess] = useState(false)
  const [userEmail, setUserEmail] = useState("")

  useEffect(async () => {
    if (currentUser) {
      clearCurrentUser()
    }
  }, [currentUser])

  const onSubmit = async ({ email }) => {
    const response = await recoverPassword(email)
      .then((res) => {
        setUserEmail(email)
        setRecoverSuccess(true)
      })
      .catch((err) => {
        switch (err?.response?.status) {
          case 400:
            showNotification(
              "Lo sentimos, el correo electrónico de recuperación de contraseña no pudo ser enviado al destinatario",
              "error"
            )
            break
          case 403:
            showNotification(
              "Tu usuario no ha sido verificado. Comunícate con el administrador para crear tus credenciales de acceso",
              "error"
            )
            break
          default:
            showNotification(
              "Lo sentimos, el correo electrónico de recuperación de contraseña no pudo ser enviado al destinatario",
              "error"
            )
        }
      })
  }

  return (
    <Grid
      container
      className={classes.recoverRoot}
      alignItems="center"
      justifyContent="center"
    >
      <Grid
        item
        xs={5.4}
        sm={5.4}
        md={5.4}
        sx={{
          height: "100vh",
          display: "flex",
          backgroundImage: `url(${fondoLogin})`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div style={{ width: "100%", padding: "33.7% 28% 0px 15%" }}>
          <p className={classes.titleText}>
            ¡<strong>Conecta</strong> con tus clientes! <br />
            <br />
            <b>Envía</b> tus campañas{" "}
            <strong>
              por <br /> SMS{" "}
            </strong>{" "}
            de forma{" "}
            <b>
              {" "}
              rápida y <br />
              segura
            </b>
            .
          </p>
        </div>
      </Grid>
      <Grid
        item
        className={classes.baseFrame}
        xs={6.6}
        sm={6.6}
        md={6.6}
        container
        direction="column"
        alignItems="center"
      >
        <div className={classes.formFrame}>
          <Grid
            item
            container
            className={classes.esmsLogo}
            justifyContent="center"
          >
            <img alt="andromeda" src={logoStock} style={{ height: "100%" }} />
          </Grid>

          <Grid
            item
            style={{
              textAlign: "center",
              marginBottom: "6px",
              letterSpacing: "0.15px",
              fontFamily: "Ubuntu, sans-serif",
              fontSize: "24px",
              lineHeight: "24px",
            }}
          >
            <p>Recuperar contraseña</p>
          </Grid>
          <Grid item container direction="column" alignItems="center">
            {recoverSuccess === false ? (
              <Grid item>
                <Typography
                  style={{
                    fontFamily: "Ubuntu, sans-serif",
                    fontSize: "16px",
                    lineHeight: "24px",
                    letterSpacing: "0.15px",
                    marginBottom: "40px",
                    textAlign: "center",
                    color: "#000",
                  }}
                >
                  Las instrucciones de recuperación de contraseña <br />
                  se enviarán al correo electrónico ingresado a <br />{" "}
                  continuación:
                </Typography>
              </Grid>
            ) : (
              <React.Fragment></React.Fragment>
            )}

            {recoverSuccess === false ? (
              <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid
                    item
                    container
                    direction="row"
                    xs={8}
                    sm={8}
                    md={8}
                    justifyContent="center"
                  >
                    <Grid item container justifyContent="center">
                      <TextField
                        id="email"
                        label="Correo electrónico"
                        variant="outlined"
                        sx={{
                          marginBottom: "38px",
                          width: "373px",
                          height: "50px",
                        }}
                        className={classes.formInput}
                        helperText={emailError?.message}
                        error={emailError !== undefined}
                        {...register("email", {
                          required: {
                            value: true,
                            message: "Campo obligatorio",
                          },
                          pattern: {
                            value: email_regex,
                            message:
                              "Correo electrónico inválido o no registrado",
                          },
                          validate: {
                            rangeLength: (value) =>
                              value.split("@")[0].length <= 64 ||
                              "Correo electrónico inválido",
                          },
                        })}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="row"
                    xs={8}
                    sm={8}
                    md={4}
                    justifyContent="center"
                  >
                    <Grid item container justifyContent="center">
                      <PrimaryButton
                        width="373px"
                        height="53px"
                        action={() => {}}
                        text="Recuperar Contraseña"
                        fontSize="20"
                        type="submit"
                      ></PrimaryButton>
                    </Grid>
                  </Grid>
                </Grid>
              </form>
            ) : (
              <Grid
                item
                container
                direction="column"
                alignItems="center"
                spacing={6}
                width={"90%"}
              >
                <Grid item>
                  <Typography
                    style={{
                      fontFamily: "Ubuntu, sans-serif",
                      fontSize: "16px",
                      lineHeight: "24px",
                      letterSpacing: "0.15px",
                      textAlign: "center",
                      marginBottom: "2px",
                    }}
                  >
                    Te hemos enviado un correo electrónico a <br />{" "}
                    <b>{userEmail}</b> con los pasos a seguir
                    <br /> para restablecer tu contraseña.
                  </Typography>
                </Grid>
                <Grid
                  item
                  sx={{ width: "100%" }}
                  container
                  justifyContent="center"
                >
                  <PrimaryButton
                    width="373px"
                    height="53px"
                    action={() => {
                      navigate("/login")
                    }}
                    text="Aceptar"
                    fontSize="20"
                  ></PrimaryButton>
                </Grid>
              </Grid>
            )}
          </Grid>
        </div>
      </Grid>
    </Grid>
  )
}

export default RecoverPassword
